import { Component, OnInit } from '@angular/core';
import { BreakpointObserver, Breakpoints } from '@angular/cdk/layout';
import { PageDataService } from 'src/app/services/page-data.service';

@Component({
    selector: 'app-home-page',
    templateUrl: './home-page.component.html',
    styleUrls: ['./home-page.component.scss']
})
export class HomePageComponent implements OnInit {
    data: any = {}
    isMobile: boolean = false;
    isHome: boolean = true;

    rootPath: string = window.location.href.slice(0, -1)

    constructor(
        private breakpointObserver: BreakpointObserver,
        public pageDataService: PageDataService
    ) { 
        breakpointObserver.observe([
            Breakpoints.HandsetLandscape,
            Breakpoints.HandsetPortrait
        ]).subscribe(result => {
            if (result.matches) {
                this.isMobile = true;
            }
            else {
                this.isMobile = false;
            }
        });
        
    } 

    ngOnInit(): void {
        this.data = {
            slides: [
                {
                    id: 'MovieSphere',
                    tag: 'Free Live TV',
                    logo: 'assets/img/home/moviesphere-large-logo.png',
                    logoMobile: 'assets/img/home/moviesphere-large-logo.png',
                    description: 'MovieSphere is the place to find blockbuster hits to indie favorites and everything in between.',
                    
                    bg: 'https://firebasestorage.googleapis.com/v0/b/lionsgatesphere.appspot.com/o/home%2F2025-q4%2Fmoviesphere-homepage-video-desktop-Q4-2025.jpg?alt=media&token=3cca033e-749c-4234-9da5-cf2fbe50cd32', 
                    
                    bgMobile: 'https://firebasestorage.googleapis.com/v0/b/lionsgatesphere.appspot.com/o/home%2F2025-q4%2Fmoviesphere-homepage-mobile-Q4-2025.jpg?alt=media&token=267639de-30ba-4bcb-b460-f782be88b19c',
                    // tt: 'https://firebasestorage.googleapis.com/v0/b/lionsgatesphere.appspot.com/o/home%2Fdec2023%2Fpaddington.png?alt=media&token=ae95bb56-118a-47f2-932f-172990247203',
                    tt: '',
                    video: 'https://firebasestorage.googleapis.com/v0/b/lionsgatesphere.appspot.com/o/home%2F2025-q4%2Fmoviesphere-homepage-video-desktop-Q4-2025.mp4?alt=media&token=1190b3a8-47cf-4ddd-8374-be9c21dee074',
                    // videoMob: 'https://firebasestorage.googleapis.com/v0/b/lionsgatesphere.appspot.com/o/moviesphere-assets%2Fsept2024%2Fmoviesphere-homepage-mobile-winter2024.mp4?alt=media&token=7d75d275-65dc-4734-9407-58e4e22ed6f3',
                    videoMob: 'https://firebasestorage.googleapis.com/v0/b/lionsgatesphere.appspot.com/o/home%2F2025-q4%2Fmoviesphere-homepage-mobile-Q4-2025.mp4?alt=media&token=8c9c4a72-0c91-405e-a794-90090fce5111',
                    sizzleVideoLabel: 'Channel Preview',
                    button: {
                        colorBG: '#ff5163',
                        color: "#fff",
                        label: 'TV Schedule',
                        url: '/movie-sphere',
                    },
                    thumb: 'assets/img/home/logos/moviesphere-logo-small-desktop.png',
                    thumbMobile: 'assets/img/home/moviesphere-square-thumb.jpg',
                },
                {
                    id: '50CentAction',
                    tag: 'Free Live TV',
                    logo: 'assets/img/home/50centaction/50centaction-logo-desktop.png',
                    logoMobile: 'assets/img/home/50centaction/50centaction-logo-desktop.png',
                    description: '50 Cent Action brings you high-octane movies and series, curated by 50 Cent himself, for the ultimate thrill ride.',
                    bg: 'https://firebasestorage.googleapis.com/v0/b/lionsgatesphere.appspot.com/o/home%2F2025-q4%2F50centaction-homepage-video-desktop-Q4-2025.jpg?alt=media&token=53704e1d-2a38-4222-8a83-2dbc1bdb8764',
                    
                    bgMobile: 'https://firebasestorage.googleapis.com/v0/b/lionsgatesphere.appspot.com/o/home%2F2025-q4%2F50centaction-homepage-video-mobile-Q4-2025.jpg?alt=media&token=cb6ae4b9-da1d-4653-9fc3-7876090a0e10',
                    tt: '',
                    // video: 'https://firebasestorage.googleapis.com/v0/b/lionsgatesphere.appspot.com/o/home%2F50centaction%2F50centaction-homepage-video-desktop-Q4.mp4?alt=media&token=bc0037f2-0080-40d9-b046-a09fb8403d0d',
                    video: 'https://firebasestorage.googleapis.com/v0/b/lionsgatesphere.appspot.com/o/home%2F2025-q4%2F50centaction-homepage-video-desktop-Q4-2025.mp4?alt=media&token=f8c74f6e-e598-4400-8ae5-b977f61f3439',
                    // videoMob: 'https://firebasestorage.googleapis.com/v0/b/lionsgatesphere.appspot.com/o/home%2F50centaction%2F50centaction-homepage-video-mobile-Q4.mp4?alt=media&token=8696bfb3-ff60-4268-8024-e6479e4a6ff1',
                    videoMob: 'https://firebasestorage.googleapis.com/v0/b/lionsgatesphere.appspot.com/o/home%2F2025-q4%2F50centaction-homepage-video-mobile-Q4-2025.mp4?alt=media&token=dfa95cd1-4376-4ad5-a226-c28052c4c925',
                    sizzleVideoLabel: 'Channel Preview',
                    // sizzleVideoLabel: '',
                    button: {
                        colorBG: '#FE0002',
                        color: '#fff',
                        label: 'TV Schedule',
                        url: '/50centaction',
                    },
                    thumb: 'assets/img/home/logos/50centaction-logo-small-desktop.png',
                    thumbMobile: 'assets/img/home/50centaction/50centaction-square-mobile.jpg',
                },
                {
                    id: 'hersphere',
                    tag: 'Free Live TV',
                    logo: 'assets/img/home/hersphere-large-logo.png',
                    logoMobile: 'assets/img/home/hersphere-large-logo.png',
                    description: 'HerSphere brings together the female-driven stories you love from Lionsgate’s premium library and beyond.',
                    // bg: 'assets/img/home/homepage-hersphere.jpg',
                    // bg: 'https://firebasestorage.googleapis.com/v0/b/lionsgatesphere.appspot.com/o/home%2Fhersphere-q4-2024%2Fhersphere-homepage-video-desktop-winter2024.jpg?alt=media&token=adff3a25-892b-4f69-bc14-342311266d34',
                    bg: 'https://firebasestorage.googleapis.com/v0/b/lionsgatesphere.appspot.com/o/home%2F2025-q4%2Fhersphere-homepage-video-desktop-Q4-2025.jpg?alt=media&token=7609abc7-1a41-43e0-8a50-5872f14420b7',
                    // bgMobile: 'https://firebasestorage.googleapis.com/v0/b/lionsgatesphere.appspot.com/o/home%2Fhersphere-q4-2024%2Fhersphere-homepage-video-mobile-winter2024.jpg?alt=media&token=525adbf2-f468-41eb-bada-6046e4a1599f',
                    bgMobile: 'https://firebasestorage.googleapis.com/v0/b/lionsgatesphere.appspot.com/o/home%2F2025-q4%2Fhersphere-homepage-video-mobile-Q4-2025.jpg?alt=media&token=bcb2f038-c4f4-4dc1-86a5-0e42ba7e7372',
                    tt: '',
                    // video: 'https://firebasestorage.googleapis.com/v0/b/lionsgatesphere.appspot.com/o/home%2Fhersphere-q4-2024%2Fhersphere-homepage-video-desktop-winter2024.mp4?alt=media&token=0f3826e1-7700-44ae-9186-7086e68890ce',
                    video: 'https://firebasestorage.googleapis.com/v0/b/lionsgatesphere.appspot.com/o/home%2F2025-q4%2Fhersphere-homepage-video-desktop-Q4-2025.mp4?alt=media&token=32ef3cc2-5380-41ae-95f0-51b8d04dcb0d',
                    // videoMob: 'https://firebasestorage.googleapis.com/v0/b/lionsgatesphere.appspot.com/o/home%2Fhersphere-q4-2024%2Fhersphere-homepage-video-mobile-winter2024-v2.mp4?alt=media&token=f721a3c1-1ad3-4d53-af07-f0309dbc9a47',
                    videoMob: 'https://firebasestorage.googleapis.com/v0/b/lionsgatesphere.appspot.com/o/home%2F2025-q4%2Fhersphere-homepage-video-mobile-Q4-2025.mp4?alt=media&token=6c9bed07-a483-4f09-9cfa-415713fa3e12',
                    sizzleVideoLabel: 'Channel Preview',
                    button: {
                        colorBG: '#2efbac',
                        color: '#000',
                        label: 'TV Schedule',
                        url: '/her-sphere',
                    },
                    thumb: 'assets/img/home/logos/hersphere-logo-small-desktop.png',
                    thumbMobile: 'assets/img/home/hersphere-square-thumb.jpg',
                },
                {
                    id: 'ebonytv',
                    tag: 'Free Live TV',
                    logo: 'assets/img/home/ebonytv-large-logo-v2.png',
                    logoMobile: 'assets/img/home/ebonytv-large-logo-v2.png',
                    description: 'EBONY TV features award-winning films, engaging comedies, and groundbreaking series that celebrate the global richness of Black culture.',
                    // bg: 'https://firebasestorage.googleapis.com/v0/b/lionsgatesphere.appspot.com/o/home%2Febony-tv-q4%2Febonytv-homepage-video-desktop-winter-2024.jpg?alt=media&token=30d57350-bf89-4f28-b3b4-7cb80be4af6d',
                    bg: 'https://firebasestorage.googleapis.com/v0/b/lionsgatesphere.appspot.com/o/home%2F2025-q4%2Febonytv-homepage-video-desktop-Q4-2025.jpg?alt=media&token=9d7e0d50-0756-4292-88da-d038845e105c',
                    
                    // bgMobile: 'https://firebasestorage.googleapis.com/v0/b/lionsgatesphere.appspot.com/o/home%2Febony-tv-q4%2Febonytv-homepage-video-mobile-Q3-2024.jpg?alt=media&token=306f0247-67ee-45ab-a2dd-0add94c6c6eb',
                    bgMobile: 'https://firebasestorage.googleapis.com/v0/b/lionsgatesphere.appspot.com/o/home%2F2025-q4%2Febonytv-homepage-video-mobile-Q4-2025.jpg?alt=media&token=e9316539-330f-4d9d-9b98-e89fea362ac5',
                    tt: '',
                    // video: 'https://firebasestorage.googleapis.com/v0/b/lionsgatesphere.appspot.com/o/home%2Febony-tv-q4%2Febonytv-homepage-video-desktop-winter-2024.mp4?alt=media&token=adc45230-b24b-411b-a11c-4940d32d40af',
                    video: 'https://firebasestorage.googleapis.com/v0/b/lionsgatesphere.appspot.com/o/home%2F2025-q4%2Febonytv-homepage-video-desktop-Q4-2025.mp4?alt=media&token=b9f6a688-f727-4d42-bbd6-1aeab9af0d6c',
                    // videoMob: 'https://firebasestorage.googleapis.com/v0/b/lionsgatesphere.appspot.com/o/home%2Febony-tv-q4%2Febonytv-homepage-video-mobile-Q3-2024-v2.mp4?alt=media&token=915904af-2547-47b3-8315-69700b3585a2',
                    videoMob: 'https://firebasestorage.googleapis.com/v0/b/lionsgatesphere.appspot.com/o/home%2F2025-q4%2Febonytv-homepage-video-mobile-Q4-2025.mp4?alt=media&token=9565f260-07b9-45e0-a1fd-ac52e2a00997',
                    sizzleVideoLabel: 'Channel Preview',
                    button: {
                        colorBG: '#e02b2e',
                        color: '#fff',
                        label: 'TV Schedule',
                        url: '/ebonytv',
                    },
                    thumb: 'assets/img/home/logos/ebonytv-logo-small-desktop.png',
                    thumbMobile: 'assets/img/home/ebonytv-square-thumb.jpg',
                },
                {
                    id: 'outersphere',
                    tag: 'Free Live TV',
                    logo: 'assets/img/home/outersphere-large-logo.png',
                    logoMobile: 'assets/img/home/outersphere-large-logo.png',
                    description: 'From superheroes to the supernatural, monsters to magicians, blockbusters to cult classics, OuterSphere has your sci-fi favorites.',
                    // bg: 'assets/img/home/homepage-ebonytv.jpg',
                    bg: 'https://firebasestorage.googleapis.com/v0/b/lionsgatesphere.appspot.com/o/outersphere-posters%2Fspring2024%2FOutersphere-homepage-static-desktop.jpg?alt=media&token=4f72b3bf-1b1a-42ec-b889-07d683a94c7f',
                    bgMobile: 'https://firebasestorage.googleapis.com/v0/b/lionsgatesphere.appspot.com/o/outersphere-posters%2Fspring2024%2FOutersphere-homepage-static-mobile-Andromeda.jpg?alt=media&token=f061182e-c199-4365-97ca-7bdde26d147d',
                    tt: '',
                    video: 'https://firebasestorage.googleapis.com/v0/b/lionsgatesphere.appspot.com/o/outersphere-posters%2Fspring2024%2FOutersphere-homepage-video-desktop.mp4?alt=media&token=670f620a-2b73-483f-9ee1-8516b4f2d2fe',
                    videoMob: 'https://firebasestorage.googleapis.com/v0/b/lionsgatesphere.appspot.com/o/outersphere-posters%2Fspring2024%2FOutersphere-homepage-video-mobile-Andromeda.mp4?alt=media&token=122473c8-46f7-46d8-b912-6c73c68b5ba3',
                    sizzleVideoLabel: 'Channel Preview',
                    button: {
                        colorBG: '#95e42c',
                        color: '#000',
                        label: 'TV Schedule',
                        url: '/outer-sphere',
                    },
                    thumb: 'assets/img/home/logos/outersphere-logo-small-desktop.png',
                    thumbMobile: 'assets/img/home/outersphere-square-thumb.jpg',
                },
                {
                    id: 'lawless',
                    tag: '',
                    logo: 'assets/img/home/lawless-large-logo-temp-v2.png',
                    logoMobile: 'assets/img/lawless/lawless-homepage-promo-logo-mobile_480.png',
                    isLargeLogo: true,
                    largeLogo: 'assets/img/lawless/LAWLESS-large-logo-desktop-v2.png',
                    descriptionColor: '#c7b092',
                    description: 'Dive into the criminal underworld where justice is a game, and the stakes are high.',
                    // bg: 'assets/img/home/homepage-ebonytv.jpg',
                    bg: 'https://firebasestorage.googleapis.com/v0/b/lionsgatesphere.appspot.com/o/home%2F2025-q3%2Flawless-page-top-background-desktop-v2.jpg?alt=media&token=9a9e466e-a4a2-40e9-a259-97835735208e',
                    bgMobile: 'assets/img/lawless/lawless-homepage-promo-background-mobile.jpg',
                    tt: '',
                    video: '',
                    videoMob: '',
                    sizzleVideoLabel: '',
                    button: {
                        colorBG: '#895614',
                        color: '#fff',
                        label: 'TV Schedule',
                        url: '/lawless',
                    },
                    thumb: 'assets/img/home/logos/lawless-logo-small-desktop-v2.png',
                    thumbMobile: 'assets/img/home/lawless-square-thumb-mobile-v2.jpg',
                },
                {
                    id: 'extreme-jobs',
                    tag: '',
                    logo: 'assets/img/extreme-jobs/Extreme-Jobs-title.png',
                    logoMobile: 'assets/img/extreme-jobs/Extreme-Jobs-title.png',
                    isLargeLogo: true,
                    largeLogo: 'assets/img/extreme-jobs/Extreme-Jobs-large-logo.png',
                    descriptionColor: '#fff',
                    description: 'Experience thrilling gold rushes, high seas drama, masterful log home builds, dedicated animal care in the Scottish Highlands, and adrenaline-pumping storm chases. Every show is an adventure.',
                    // bg: 'assets/img/home/homepage-ebonytv.jpg',
                    bg: 'https://firebasestorage.googleapis.com/v0/b/lionsgatesphere.appspot.com/o/home%2F2025-q3%2FExtreme-Jobs-page-top-background-desktop-v2.jpg?alt=media&token=c0c17207-0042-4bae-a633-ea0aaaa0a2f7',
                    bgMobile: 'assets/img/extreme-jobs/Extreme-Jobs-page-background-top-mobile.jpg',
                    tt: '',
                    video: '',
                    videoMob: '',
                    sizzleVideoLabel: '',
                    button: {
                        colorBG: '#678e8e',
                        color: '#fff',
                        label: 'TV Schedule',
                        url: '/extreme-jobs',
                    },
                    thumb: 'assets/img/home/logos/Extreme-Jobs-logo-small-desktop.png',
                    thumbMobile: 'assets/img/home/Extreme-Jobs-square-thumb-mobile.jpg',
                },
                
            ],
            showList: [
                {
                    thumb: 'assets/img/channel/designated-survivor/designated-surviovor-large-rectangle.jpg',
                    small: 'assets/img/channel/designated-survivor/designated-survivor-small-rectangle.jpg',
                    url: '/channel/designated-survivor',
                },
                {
                    thumb: 'assets/img/channel/new2/the-conners-large-rectangle.jpg',
                    small: 'assets/img/channel/new2/the-conners-small-rectangle.jpg',
                    url: '/channel/the-conners',
                },
                {
                    thumb: 'assets/img/channel/new2/nash-bridges-large-rectangle.jpg',
                    small: 'assets/img/channel/new2/nash-bridges-small-rectangle.jpg',
                    url: '/channel/nash-bridges',
                },
                // {
                //     thumb: 'assets/img/channel/new2/grace-and-frankie-large-rectangle.jpg',
                //     small: 'assets/img/channel/new2/grace-and-frankie-small-rectangle.jpg',
                //     url: '/channel/grace-and-frankie',
                // },
                {
                    thumb: 'assets/img/home/are-we-there-yet-large-rectangle.jpg',
                    small: 'assets/img/home/are-we-there-yet-small-rectangle.jpg',
                    url: '/channel/are-we-there-yet',
                },
                {
                    thumb: 'assets/img/home/anger-management-large-rectangle.jpg',
                    small: 'assets/img/home/anger-management-small-rectangle.jpg',
                    url: '/channel/anger-management',
                },
                {
                    thumb: 'assets/img/home/ghost-hunters-large-rectangle.jpg',
                    small: 'assets/img/home/ghost-hunters-small-rectangle.jpg',
                    url: '/channel/ghost-hunters',
                },
                {
                    thumb: 'assets/img/home/wanted-dead-or-alive-large-rectangle.jpg',
                    small: 'assets/img/home/wanted-dead-or-alive-small-rectangle.jpg',
                    url: '/channel/wanted-dead-or-alive',
                },
                {
                    thumb: 'assets/img/home/celebrity-wedding-large-rectangle.jpg',
                    small: 'assets/img/home/celebrity-wedding-small-rectangle.jpg',
                    url: '/channel/celebrity-name-game',
                },
                {
                    thumb: 'assets/img/home/caught-in-providence-large-rectangle.jpg',
                    small: 'assets/img/home/caught-in-providence-small-rectangle.jpg',
                    url: '/channel/caught-in-providence',
                },


                {
                    thumb: 'assets/img/home/nashville-large-rectangle.jpg',
                    small: 'assets/img/home/nashville-small-rectangle.jpg',
                    url: '/channel/nashville',
                },
                {
                    thumb: 'assets/img/home/love-thy-neighbor-large-rectangle.jpg',
                    small: 'assets/img/home/love-thy-neighbor-small-rectangle.jpg',
                    url: '/channel/love-thy-neighbor',
                },
                
                {
                    thumb: 'assets/img/home/wendy-williams-large-rectangle.jpg',
                    small: 'assets/img/home/wendy-williams-small-rectangle.jpg',
                    url: '/channel/wendy-williams',
                },
                {
                    thumb: 'assets/img/home/weeds-nurse-jackie-large-rectangle.jpg',
                    small: 'assets/img/home/weeds-nurse-jackie-small-rectangle.jpg',
                    url: '/channel/weeds-and-nurse-jackie',
                },
                {
                    thumb: 'assets/img/channel/heartland/heartland-large-rectangle.jpg',
                    small: 'assets/img/channel/heartland/heartland-small-rectangle.jpg',
                    url: '/channel/heartland',
                },
                {
                    thumb: 'assets/img/channel/wicked-tuna/wicked-tuna-large-rectangle.jpg',
                    small: 'assets/img/channel/wicked-tuna/wicked-tuna-small-rectangle.jpg',
                    url: '/channel/wicked-tuna',
                },
                
                
                
            ]
        }
    }

    

}
